<div class="cCityHeader">
    <div class="cCityHeaderText">Select the city that you want to visit today!</div>
    <div class="cCitySearchBox">
        <input type="text" placeholder="Search your city"
            (keyup)="FilterCities($event.target.value);" />
    </div>
</div>
<div class="cPortalCitiesPopup">
    <div class="row">
        <div class="col-lg-2" *ngFor="let item of ManikCitiesList">
            <div (click)="SetCity(item.CityID)">
                <p>{{item.CityName}}</p>
            </div>
        </div>
    </div>
</div>